module.exports = __webpack_public_path__ + "img/about-show2.908cd033.png";